const apiLink = 'https://api.softpro.me/CustomersAPIs/1272102216/';


export default apiLink;